import {
	Model,
	User,
	YardSchedule
} from ".";

export default class Salesman extends Model {
	get singularNoun() {
		return "salesman";
	}

	get pluralNoun() {
		return "salesmen";
	}

	get mutations() {
		return {
			schedules: YardSchedule,
			user: User
		};
	}

	resource() {
		return "sales/salesmen";
	}
}
